import { Pipe, PipeTransform } from '@angular/core';
import { LAMStatus } from '../global-types';

const statusMap: Record<LAMStatus, string> = {
  [LAMStatus.readyForUse]: 'Ready for Use',
  [LAMStatus.notAvailable]: 'Not Available',
  [LAMStatus.maintenanceNeeded]: 'Needs Maintenance',
  [LAMStatus.inspectionNeeded]: 'Needs Inspection',
  [LAMStatus.inCustody]: 'In Custody',
  [LAMStatus.reserved]: 'Reserved',
};

@Pipe({
  name: 'trailerStatus',
  standalone: false,
})
export class TrailerStatusPipe implements PipeTransform {
  public transform(value: LAMStatus): string {
    return statusMap[value] || value;
  }
}
